import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rm-main',
  template: `
    <div class="col-md-8 col-md-offset-1 col-md-push-3">
      <div class="col-md-10">
        <div class="row featurette">
          <div>
            <h2>Hello and Welcome.<br></h2>
            <p class="lead">I'm an Angular developer located in North Carolina. My main focus is on the front-end. I've done some work on the back-end mostly with MySQL, Node and PERL. I build websites from scratch, from HTML 5 templates, with Angular 1, Angular 2 and Wordpress. 
          </div>
        </div>
        <div class="row featurette">
          <div>
            <h2>Teamwork <span class="color_darkred">experiences</span>.<br>
              <span class="text-muted">And what I've done.</span></h2>
            <p class="lead">My function on teams have included anything from full site builds from the ground up to creating new features in existing sites and applications. I've programmed in Javascript, PHP, PERL with a little IOS thrown in.
              My experience so far has been educational to say the least and very challenging because the field is
              constantly in flux. Always a student and eager to learn more.</p>
          </div>
        </div>
        <div class="row featurette">
          <div>
            <h2>Past workplace <span class="color_darkred">history</span>.<br><span
              class="text-muted">And future plans.</span></h2>
            <p class="lead">All of my work has been for local, small, businesses in Colorado, and North Carolina. I’ve had
              the great pleasure to work with incredibly talented designers and developers. I hope to continue to be active in the developer community.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3 col-md-pull-9 hidden-sm hidden-xs">
      <rm-flipper horizontal></rm-flipper>
    </div>
  `,
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/main/main.component.ts